/** CUSTOMER-R4.5 — production BANK_IBAN_ONLY: no card-brand NovaPay copy. */
import type { StoreV2Lang } from "./store-v2-locale.js";

export function CardBrandTrustBlock(_props: {
  lang: StoreV2Lang;
  compact?: boolean;
  testId?: string;
}): null {
  return null;
}
